export default __webpack_public_path__ + "static/media/tr.3384f7b6.svg";